import BaseInput from "../../../baseComponents/baseInput.js";
import BaseButton from "../../../baseComponents/baseButton.js";
import { useRef, useEffect, useState } from "react";
import LoginTemplate from "../LoginTemplate.js";
import { asyncActions as loginAsyncActions } from "../../../store/slices/loginSlice.js";
import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import BaseHyperlink from "../../../baseComponents/baseHyperlink.js";

const ForgotPasswordView = ({
  title,
  autoRelogin = true,
  afterLoginRoutesPath = [],
}) => {
  /////////////////////////////////////////////////////////////////////////////////////////////dispatcher, navigator
  const dispatch = useDispatch();
  const navigate = useNavigate();

  /////////////////////////////////////////////////////////////////////////////////////////////redux states

  /////////////////////////////////////////////////////////////////////////////////////////////local states
  const [emailInput, setEmailInput] = useState("");
  const [tokenRequested, setTokenRequested] = useState(false);
  const [tokenRequestMethod, setTokenRequestMethod] = useState();
  const [errorMsg, setErrorMsg] = useState("");

  /////////////////////////////////////////////////////////////////////////////////////////////handling inputs
  const handleEmailInput = (e) => {
    clearError();
    setEmailInput(e.target.value);
  };

  /////////////////////////////////////////////////////////////////////////////////////////////styles
  const styles = {
    button: {
      paddingLeft: "1em",
      paddingRight: "1em",
      paddingTop: "0.5em",
      paddingBottom: "0.5em",
    },
  };

  /////////////////////////////////////////////////////////////////////////////////////////////refs
  const emailRef = useRef();

  /////////////////////////////////////////////////////////////////////////////////////////////methods
  const clearError = () => {
    setErrorMsg("");
    return true;
  };

  const navigateToRoot = () => {
    navigate("/");
    return true;
  };

  const generateToken = async ({  pUserIdentifier }) => {
    clearError();
    await dispatch(
      loginAsyncActions.generateChangePassToken({
        pUserIdentifier: pUserIdentifier,
        navigate: navigate,
        setErrorMsg: setErrorMsg,
        setTokenRequested: setTokenRequested,
        setTokenRequestMethod: setTokenRequestMethod,
      })
    );
   
  };

  /////////////////////////////////////////////////////////////////////////////////////////////effects

  /////////////////////////////////////////////////////////////////////////////////////////////render

  return (
    <LoginTemplate
      heading={title}
      autoRelogin={autoRelogin}
      onEnter={() => generateToken({  pUserIdentifier: emailInput })}
      success={
        tokenRequested &&
        (tokenRequestMethod === "E"
          ? "changePasswordTokenCreated"
          : "changePasswordSmsTokenSent")
      }
      focusElement={emailRef}
      afterLoginRoutesPath={afterLoginRoutesPath}
    >
      {!tokenRequested && (
        <>
          <BaseInput
            type="email"
            placeholder="emailAdressOrPhoneNumber"
            innerRef={emailRef}
            value={emailInput}
            onChange={handleEmailInput}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <BaseHyperlink bold to="/forgotPasswordMobile?mobile=unknown" style={{ fontSize: "19px" }}>
              alreadyGotSmsConfirmationCode
            </BaseHyperlink>
          </div>
          <BaseButton
            error={errorMsg}
            onClick={() => {
              generateToken({  pUserIdentifier: emailInput });
            }}
          >
            sendConfirmationCode
          </BaseButton>
        </>
      )}
      <BaseButton style={styles.button} onClick={navigateToRoot}>
        homePage
      </BaseButton>
    </LoginTemplate>
  );
};

export default ForgotPasswordView;

//forgotPasswordTitle
